import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconGearGuide = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={20}
    fill="none"
    viewBox="0 0 26 20"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.95}
      d="M25.5 9.414V15c0 .703-.586 1.25-1.25 1.25H23c-.703 0-1.25-.547-1.25-1.25V9.414l-.117-.312-1.758-3.204V17.5c0 1.406-1.133 2.5-2.5 2.5h-8.75a2.468 2.468 0 0 1-2.5-2.5V5.898L4.328 9.102l-.078.312V15c0 .703-.586 1.25-1.25 1.25H1.75C1.047 16.25.5 15.703.5 15V9.414c0-.742.156-1.484.547-2.148L3.82 2.305C4.406 1.289 5.5.625 6.672.625H9.25c0 2.11 1.64 3.75 3.75 3.75 2.07 0 3.75-1.64 3.75-3.75h2.54c1.17 0 2.265.664 2.85 1.68l2.774 4.96c.39.665.586 1.407.586 2.15Z"
    />
  </svg>
));
export default SvgIconGearGuide;
